import React from 'react';
import * as S from './AnotherBookingPopupStyles';

const AnotherBookingPopup = ({
  shouldShow = false,
  onPositiveAction,
  onNegativeAction,
  popupDetails
}) => {
  return shouldShow ? (
    <S.ModalWebWrapper>
      <S.ModalContainer>
        <S.TitleCont>
          {popupDetails.title}
        </S.TitleCont>
        <S.SubtitleCont dangerouslySetInnerHTML={{
          __html: popupDetails?.subTitle
        }}>
        </S.SubtitleCont>
        <S.ButtonCont>
          <div className="positiveActionBtn" onClick={onPositiveAction}>{popupDetails?.positiveAction}</div>
          <div className="negativeActionBtn" onClick={onNegativeAction}>{popupDetails?.negativeAction}</div>
        </S.ButtonCont>
      </S.ModalContainer>
    </S.ModalWebWrapper>
  ) : null;
};

export default AnotherBookingPopup;